import { useNow } from '@/lib/hooks';
import { countdown } from '@/lib/format';

export interface ToggleProps {
  checked: boolean;
  onChange: (next: boolean) => void;
  label: string;
  description?: string;
  disabled?: boolean;
  /** Production controls pass this and the remaining seconds render next to the switch. */
  cooldownUntil?: string | null;
}

/**
 * A switch. Production controls never toggle on click alone: the surface that owns them
 * opens a ConfirmDialog first and only calls onChange after the ceremony.
 */
export function Toggle({
  checked,
  onChange,
  label,
  description,
  disabled = false,
  cooldownUntil,
}: ToggleProps) {
  const now = useNow(1000);
  const cooling = Boolean(cooldownUntil) && Date.parse(cooldownUntil ?? '') > now;

  return (
    <div className="o-row">
      <button
        type="button"
        role="switch"
        className="o-toggle"
        aria-checked={checked}
        aria-label={label}
        disabled={disabled || cooling}
        onClick={() => onChange(!checked)}
      >
        <span className="o-toggle__track">
          <span className="o-toggle__knob" />
        </span>
        <span>
          <span>{label}</span>
          {description ? <span className="o-muted"> {description}</span> : null}
        </span>
      </button>
      {cooling ? (
        <span className="o-toggle__cooldown">cooldown {countdown(cooldownUntil ?? null, now)}</span>
      ) : null}
    </div>
  );
}
